
import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from './login.service';
import { NgClass } from '@angular/common';
import { CognitoCallback, ForgotPasswordCallback } from '../cognito/cognito.service';
import { UserLoginService } from '../cognito/user-login.service';
import { JwtHelper } from 'angular2-jwt';
import { ProjectDataService } from '../shared/dataservice.service';
import { NavbarService } from '../navbar/navbar.service';

import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';

declare var pendo: any;

@Component({
  selector: 'app-login',
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.css'],
  providers: [LoginService, UserLoginService]
})
export class MRLoginComponent implements OnInit, OnDestroy, CognitoCallback, ForgotPasswordCallback {

  private sub: any;
  loginicon = 'mdi mdi-login right';
  errorMessage: string;
  loginmessage: string = '';
  forgotpasswordmessage: string = '';
  forgotpasswordemail: string = '';
  changepasswordmessage: string = '';
  changepasswordcode: string = '';
  changepasswordpassword: string = '';
  changepasswordconfirm: string = '';
  validationerror: boolean = false;
  username: string;
  password: string;
  _projectDataService: any;
  active: boolean = false;
  modalForgotPasswordAction = new EventEmitter<string | MaterializeAction>();

  constructor(private loginService: LoginService, private router: Router, private route: ActivatedRoute,
    private projectDataService: ProjectDataService,
    private userLoginService: UserLoginService,
    public navService: NavbarService) {
    this._projectDataService = projectDataService;
  }

  ngOnInit() {
    this.navService.hide();
    this.sub = this.route.params.subscribe(params => {
      let value = params['val'];

      if (value == 1) {
        console.log('User Registered');
        this.loginmessage = 'Registration successful.  Please log in.';
      } else if (value == 2) {
        console.log('Password changed');
        this.loginmessage = 'Password changed.  Please log in.';
      } else if (value == 3) {
        console.log('User Registered');
        this.loginmessage = 'Registration successful - please log in. Also check your Inbox for an email to verify your account.';
        // this.username = params['email']; commented since the "active" class doesn't work on the label to move it out of the way
        // console.log('Username:', this.username);
      } else {
        this.loginmessage = '';
      }
    });

    localStorage.setItem('token', '');
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
    this.modalForgotPasswordAction.emit({ action: 'modal', params: ['close'] });
  }

  onRegister() {
    this.router.navigate(['/register']);
  }

  onChangePassword() {
    this.router.navigate(['/changepassword']);
  }

  onLogin() {
    if (this.active) {
      return;
    }

    if (this.username == null || this.password == null) {
      this.errorMessage = 'All fields are required';
      return;
    }

    this.active = true;
    this.loginicon = 'fa right fa-spinner fa-pulse';
    this.errorMessage = null;
    this.username = this.username.toLowerCase();
    this._projectDataService.setForceUpdateBool(true);
    this.userLoginService.authenticate(this.username, this.password, this);
  }

  cognitoCallback(message: string, result: any) {
    console.log('cognitoCallback called');
    this.active = false;

    if (message != null) { // Some error occured
      this.errorMessage = message;
      console.log('ERROR: ' + this.errorMessage);
      this.loginicon = 'mdi mdi-login right';
    }

    console.log('other route');
    console.log('RESULT:', result);
    let accessToken = result.accessToken.jwtToken;
    let idToken = result.idToken.jwtToken;
    let refreshToken = result.refreshToken.token;
    // console.log('ACCESS TOKEN:', accessToken);
    // console.log('ID TOKEN:', idToken);
    console.log('REFRESH TOKEN:', refreshToken);

    let jwtHelper = new JwtHelper();
    let decoded = jwtHelper.decodeToken(idToken);

    localStorage.setItem('mr_email', this.username);
    localStorage.setItem('token', accessToken);

    this.loginService.postLogin()
      .subscribe(
      data => {
        console.log('postLogin complete');
        this.loginicon = 'mdi mdi-login right';

        console.log('DATA:', data);

        let logindata = JSON.parse(data);
        let planid = logindata.planid;
        let tenantid = logindata.tenantid;
        let tenantdataurl = logindata.tenantdataurl;

        console.log('planid:', planid);
        console.log('tenantid:', tenantid);
        console.log('tenantdataurl:', tenantdataurl);

        // refactor localStorages to localSessions
        localStorage.setItem('mr_planid', planid);
        localStorage.setItem('mr_tenantid', tenantid);
        localStorage.setItem('mr_tenantdataurl', tenantdataurl);

        /* initialize Pendo now that we're logged in */
        pendo.initialize({
          visitor: {
            id: this.username
          },
          account: {
            name: tenantid
          }
        });

        console.log('Pendo initialized');

        this.navService.configure();

        if (planid > 1) {
          let adminsettings = logindata.settings[0];
          let isAdmin = false;

          if (logindata.hasOwnProperty('roles')) {
            logindata.roles.forEach(element => {
              if (element.roleid == 1) {
                isAdmin = true;
              }
            });
          }

          console.log('settings', adminsettings);

          if (isAdmin) {
            localStorage.setItem('isAdmin', 'true');
          } else {
            localStorage.setItem('isAdmin', 'false');
          }

          let settingtables = '{"dateformats":[{"id":1,"date_format":"MM/dd/yyyy","enabled":1},{"id":2,"date_format":"MM/dd/yy","enabled":1},{"id":3,"date_format":"yyyy/MM/dd","enabled":1},{"id":4,"date_format":"yy/MM/dd","enabled":1},{"id":5,"date_format":"dd/MM/yyyy","enabled":1},{"id":6,"date_format":"dd/MM/yy","enabled":1}],"currencies":[{"id":1,"name":"US Dollar","short_name":"USD","symbol":"$","enabled":1},{"id":2,"name":"Canadian Dollar","short_name":"CAD","symbol":"$","enabled":1},{"id":3,"name":"Euro","short_name":"EUR","symbol":"€","enabled":1},{"id":4,"name":"British Pound","short_name":"GBP","symbol":"£","enabled":1},{"id":5,"name":"Mexican Peso","short_name":"MXN","symbol":"$","enabled":1}]}';
          let settingstablejson = JSON.parse(settingtables);

          let dateformats = settingstablejson.dateformats;
          let currencies = settingstablejson.currencies;

          let dateFormatsDict = [];
          for (let i = 0; i < dateformats.length; i++){
            dateFormatsDict[dateformats[i].id] = dateformats[i].date_format;
          }
          let currenciesNameDict = [], currenciesSymbolDict = [], currenciesShort_nameDict = [];
          for (let i = 0; i < currencies.length; i++){
            currenciesNameDict[currencies[i].id] = currencies[i].name;
            currenciesSymbolDict[currencies[i].id] = currencies[i].symbol;
            currenciesShort_nameDict[currencies[i].id] = currencies[i].short_name;
          }

          localStorage.setItem('mr_date_format_id', dateFormatsDict[adminsettings.date_format_id]);
          localStorage.setItem('mr_currency_id', currenciesShort_nameDict[adminsettings.currency_id]);
          localStorage.setItem('mr_currency_symbol', currenciesSymbolDict[adminsettings.currency_id]);
          localStorage.setItem('mr_quote_auto_sequence_enabled', adminsettings.quote_auto_sequence_enabled);
          localStorage.setItem('mr_quote_auto_sequence_start', adminsettings.quote_auto_sequence_start);
          localStorage.setItem('mr_quote_auto_sequence_padding', adminsettings.quote_auto_sequence_padding);
          localStorage.setItem('mr_quote_contact_info', adminsettings.quote_contact_info);
          localStorage.setItem('mr_quote_document_footer', adminsettings.quote_document_footer);

          this.router.navigate(['/workspace']);
        } else {
          this.router.navigate(['/bernie']);
        }
      },
      error => {
        this.errorMessage = <any>error;
        this.loginicon = 'mdi mdi-login right';
        console.error('postLogin() error:', this.errorMessage);
      });
  }

  openForgotPasswordModal() {
    this.modalForgotPasswordAction.emit({ action: 'modal', params: ['open'] });
  }

  onForgotPassword() {
    console.log('onForgotPassword() clicked');
    this.errorMessage = null;
    this.userLoginService.forgotPassword(this.forgotpasswordemail, this);
  }

  messageSent(message: string) {
    console.log('forgotpassword route');
    localStorage.setItem('changepasswordemail', this.forgotpasswordemail);
    this.router.navigate(['/changepassword']);
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/login/login.component.ts